import {
    Button,
    Divider,
    Drawer,
    Input,
    Row,
    Table,
    Tag,
    Tooltip, Col,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";

import Plus from "../../assets/images/plus.svg";
import ConfirmationBox from "../../components/ConfirmationBox";
import DeleteModal from "../../components/DeleteModal";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import AddForm from "./AddForm";

function Index() {
    const heading = "FAQ";
    const { setPageHeading } = useContext(AppStateContext);
    const sectionName = "FAQ";

    const api = {
        list: apiPath.faqList,
        faqAddMultiple: apiPath.faqAddEdit,
        statusChange: apiPath.faqStatusChange,
        delete: apiPath.faqDelete,
    };

    const [searchText, setSearchText] = useState("");
    const { request } = useRequest();
    const { showConfirm } = ConfirmationBox();
    const [list, setList] = useState({});
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selected, setSelected] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const debouncedSearchText = useDebounce(searchText, 300);

    const [drawerVisible, setDrawerVisible] = useState(false);
    const [viewCategory, setViewCategory] = useState(null);
    const [viewFaqs, setViewFaqs] = useState([]);

    const onDelete = (id) => {
        request({
            url: api.delete + "/" + id,
            method: "POST",
            onSuccess: () => {
                setLoading(false);
                ShowToast("FAQ Deleted Successfully", Severty.SUCCESS);
                setRefresh((prev) => !prev);
                setDrawerVisible(false); // Close drawer after delete
            },
            onError: (error) => {
                setLoading(false);
                ShowToast(error, Severty.ERROR);
            },
        });
    };

    const fetchData = (pagination) => {
        request({
            url: `${api.list}?page=${pagination.current}&pageSize=${pagination.pageSize}&search=${debouncedSearchText}`,
            method: "GET",
            onSuccess: ({ data, status }) => {
                setLoading(false);
                if (status) {
                    const grouped = (data?.list || []).reduce((acc, faq) => {
                        const category = faq.category || "Uncategorized";
                        if (!acc[category]) acc[category] = [];
                        acc[category].push(faq);
                        return acc;
                    }, {});
                    setList(grouped);
                    setPagination({
                        current: data?.list?.page,
                        total: data?.list?.totalDocs,
                        pageSize: data?.list?.limit,
                    });
                }
            },
            onError: (error) => {
                setLoading(false);
                ShowToast(error, Severty.ERROR);
            },
        });
    };

    useEffect(() => {
        setPageHeading(heading);
    }, [setPageHeading]);

    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, debouncedSearchText]);

    const onSearch = (e) => {
        setSearchText(e.target.value);
    };

    return (
        <>
            <SectionWrapper
                cardHeading="FAQ List"
                extra={
                    <div className="w-100 d-flex align-items-baseline text-head_right_cont">
                        <div className="pageHeadingSearch d-flex gap-2">
                            <Input.Search
                                className="searchInput"
                                placeholder="Search By FAQ category"
                                onChange={onSearch}
                                allowClear
                            />
                        </div>
                        <Button
                            className="primary_btn btnStyle"
                            onClick={() => {
                                setVisible(true);
                                setSearchText("");
                                setSelected(null);
                            }}
                        >
                            <span className="add-Ic">
                                <img src={Plus} alt="Add" />
                            </span>
                            {sectionName}
                        </Button>
                    </div>
                }
            >
                <Table
                    rowKey="category"
                    columns={[
                        {
                            title: "Category",
                            dataIndex: "category",
                            width: 200,
                            key: "category",
                        },
                        {
                            title: "Action",
                            key: "action",
                            width: 200,
                            render: (_, record) => (
                                <Tooltip title="View FAQs">
                                    <Button
                                        className="btnStyle primary_btn"
                                        onClick={() => {
                                            setViewCategory(record.category);
                                            setViewFaqs(list[record.category]);
                                            setDrawerVisible(true);
                                        }}
                                    >
                                        <i className="fas fa-eye" />
                                    </Button>
                                </Tooltip>
                            ),
                        },
                    ]}
                    dataSource={Object.keys(list).map((cat) => ({ category: cat }))}
                    pagination={false}
                    loading={loading}
                />
            </SectionWrapper>

            {/* Drawer showing FAQs under category */}
            <Drawer
                title={<h5 className="faq-upper-headerg">
                    FAQs under {viewCategory}
                </h5>}
                placement="right"
                width={700}
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
            >
                {viewFaqs.map((faq, index) => (
                    <div key={faq._id} className="mb-3">
                        <Row justify="space-between">
                            <Col span={18}>
                                <div className="main-new-faq-headerr">
                                    <h5>{index + 1}. {faq.question}</h5>
                                    <p className="text-muted mb-1">{faq.answer}</p>
                                </div>
                            </Col>
                            <Col span={6} className="text-right">
                                <div className="main-new-add-butonflex">
                                    <Tooltip title="Edit">
                                        <Button
                                            size="small"
                                            className="btnStyle primary_btn"
                                            onClick={() => {
                                                setSelected(faq);
                                                setVisible(true);
                                                setDrawerVisible(false);
                                            }}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <Button
                                            size="small"
                                            className="btnStyle deleteDangerbtn ml-2"
                                            onClick={() => {
                                                setSelected(faq);
                                                setShowDelete(true);
                                            }}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                        <Divider className="my-2" />
                    </div>
                ))}
            </Drawer>

            {visible && (
                <AddForm
                    section={sectionName}
                    api={api}
                    show={visible}
                    hide={() => {
                        setVisible(false);
                        setSelected(null);
                    }}
                    data={selected}
                    refresh={() => setRefresh((prev) => !prev)}
                />
            )}

            {showDelete && (
                <DeleteModal
                    title={"Delete FAQ"}
                    subtitle={`Are you sure you want to delete this FAQ?`}
                    show={showDelete}
                    hide={() => {
                        setShowDelete(false);
                        setSelected(null);
                    }}
                    onOk={() => {
                        onDelete(selected?._id);
                        setShowDelete(false);
                    }}
                />
            )}
        </>
    );
}

export default Index;

